/*
 * Author M. Atoar Rahman
 * Title: Partner Stock Loss
 * Description: Page for Partner Stock Loss
 * Date: 15/06/2022
 */

import { Button, Card } from 'react-bootstrap';
import { useStockLoss } from './ContextAPI';
import DataTable from './DataTable';
import FormInfo from './FormInfo';
import ShowModel from './ShowModel';

export default function Index() {
    const { show, setShow, rowData, setRowData } = useStockLoss();
    const createHander = () => {
        setShow(true);
        setRowData('');
    };
    const backHander = () => {
        setShow(false);
        setRowData('');
    };
    return (
        <>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Partner Stock Loss</h3>
                    {show ? (
                        <div>
                            <Button
                                onClick={() => backHander()}
                                className="btnInfo"
                                variant="primary"
                            >
                                Back to List
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <Button
                                onClick={() => createHander()}
                                className="btnInfo"
                                variant="primary"
                            >
                                Create New
                            </Button>
                        </div>
                    )}
                </Card.Header>
                <Card.Body>{show ? <FormInfo editData={rowData} /> : <DataTable />}</Card.Body>
            </Card>
            <ShowModel />
        </>
    );
}
